import React from 'react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// constants
import { Modals } from 'constants/modals'
// types
import { MatrixOption, MatrixAppetite, MatrixAppetiteOption } from '../../../../types'
// views
import { Row } from '../../../../views'
// utils
import pipe from 'lodash/fp/pipe'
import find from 'lodash/fp/find'

interface Props {
  options: MatrixOption[]
  disabled: boolean
  appetite?: MatrixAppetite
  optionIdx: number
}

const AppetiteSelect: React.FC<Props> = ({ options, disabled, appetite, optionIdx }) => {
  const { showModal } = useShowModal({ modalType: Modals.RISK_MATRIX_APPETITE_OPTIONS_MODAL })

  const currentValue = appetite?.options.find(({ id }) => id === appetite?.value)

  const currentValueLabel = pipe(
    find(({ id }) => id === appetite?.value),
    (res: MatrixAppetiteOption | null) => options.find(({ id }) => id === res?.matrixOptionId),
    (res) => (res ? `${res.label} (${parseFloat(res.value)})` : null)
  )(appetite?.options)

  const color = currentValue?.color || undefined

  const showOptionsModal = () => {
    if (!disabled) {
      showModal({ optionIdx })
    }
  }

  return (
    <Row isSelect color={color} showOptions onClick={showOptionsModal} disabled={disabled}>
      {currentValueLabel || (disabled ? 'N/A' : 'Set appetite')}
    </Row>
  )
}

export default AppetiteSelect
